<div class="modal-header">
  <h3 class="modal-title">{{ 'priceSupportAgreement.search' | cxTranslate }}</h3>

  <!-- <button type="button" class="close closeModal" aria-label="Close" (click)="modal.dismiss()">
  <span aria-hidden="true">&times;</span>
</button> -->
<button type="button" class="close closeModal" aria-label="Close" (click)="closeModal()">
  <span aria-hidden="true">&times;</span>
</button>
</div>

<div class="modal-body">
  <div class="cx-order-history-form-group form-group">
    <div class="input-group">
      <input
        type="text"
        class="form-control search-input"
        id="searchOrder"
        [ngClass]="{ 'remove-radius': inputSearch }"
        [(ngModel)]="inputSearch"
        (keydown.enter)="onSearch($event.target.value)"
        [placeholder]="'priceSupportAgreement.searchHint' | cxTranslate"
        />
        <div class="input-group-append">
          @if (inputSearch) {
            <span class="input-group-text" (click)="inputSearch = null; onSearch(null)">
              <i class="fa fa-times"></i>
            </span>
          }
        </div>
      </div>
    </div>

    @if (units?.results?.length) {
      <app-custom-table
        [headers]="headers"
        [columns]="columns"
        rowId="uid"
        [rows]="units.results"
        [pagination]="units.pagination"
        (changePagination)="pageChange($event)"
        [showLoader]="showLoaderOnPagination"
        >
      </app-custom-table>
    } @else {
      @if (showMessageWhenNoData) {
        <app-custom-error errorMessage="No results found"></app-custom-error>
      }
    }


    @if (showLoaderOnStartupOrWhenNoData) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
